module.exports = __webpack_public_path__ + "img/AOSTA.86de974a.png";